import Borghi from "./borghi"
import { useState } from "react"

function BorghiVicini({ città, imgLength }) {

    const [borghi, setBorghi] = useState([])

    const dataFromBorghi = (dataFromBorghi) => { setBorghi(dataFromBorghi) }

    return (<>
        <Borghi onDataSubmit={dataFromBorghi} />

        <p style={{ padding: '10px', textAlign: 'center', margin: '2em auto', background: 'linear-gradient(to right, #f57c53, #dbd26d)' }}>
            Approfitta dell'evento per scoprire e visitare la città di <b>{città}</b> e i borghi incantevoli vicino ad essa.
        </p>
        {borghi.filter(item => item.città === città).length !== 0 &&
            <div className='mt-3' id='borghi'>
                <div>
                    {/* --------------- IMMAGINE CITTA' PER DESKTOP ------------------ */}
                    {borghi.filter(item => item.città === città).length !== 0 && imgLength === 3 &&
                        borghi
                            .filter(item => item.città === città)
                            .map((borgo, index) => (
                                <div key={index} style={{ textAlign: 'center' }} className='addImg'>
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/città/${borgo.imgCittà}`} width="60%" alt='' />
                                </div>
                            ))
                    }
                    {/* --------------- IMMAGINE CITTA' PER MOBILE ------------------ */}
                    {borghi.filter(item => item.città === città).length !== 0 &&
                        borghi
                            .filter(item => item.città === città)
                            .map((borgo, index) => (
                                <div key={index} style={{ textAlign: 'center' }} className='accordionHomeMobile'>
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/città/${borgo.imgCittà}`} width="60%" alt='' />
                                </div>
                            ))
                    }
                </div>
                <div style={{ border: '1px solid lightgrey', padding: '1rem', backgroundColor: 'whitesmoke' }}>
                    {borghi
                        .filter(item => item.città === città)
                        .map(borgo => (
                            borgo.descBorgo.map((elem, index) => (
                                <p key={index} style={{ marginBottom: '3px' }}><b>{elem.nomeBorgo}</b>
                                    <span>{elem.textBorgo}</span>
                                </p>
                            ))
                        ))}
                </div>
            </div>
        }
    </>)
}
export default BorghiVicini